import { JACHIN_REPORTING_ENABLED } from "@solomon-apps/config";
import React from "react";

import { CurrentStatsV4Page } from "./CurrentStatsV4Page";
import { LegacyStatsV4Page } from "./LegacyStatsV4Page";

export function StatsV4Page(): React.ReactElement {
    return JACHIN_REPORTING_ENABLED ? (
        <CurrentStatsV4Page />
    ) : (
        <LegacyStatsV4Page />
    );
}
